"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateScore = void 0;
var calculateScore = values => {
  if (values.riskTolerance == 'do not want to lose any of it') {
    return 0;
  }
  var score = 0;

  // CurrentAge
  if (values.currentAge < 40) {
    score += 5;
  }
  if (values.currentAge >= 40 && values.currentAge <= 54) {
    score += 3;
  }
  if (values.currentAge >= 55) {
    score += 1;
  }

  // RetirementAge
  if (values.retirementAge - values.currentAge > 20) {
    score += 5;
  }
  if (values.retirementAge - values.currentAge <= 20 && values.retirementAge - values.currentAge >= 5) {
    score += 3;
  }
  if (values.retirementAge - values.currentAge < 5) {
    score += 1;
  }
  // LifeExpectancy

  if (values.lifeExpectancy - values.retirementAge > 15) {
    score += 5;
  }
  if (values.lifeExpectancy - values.retirementAge <= 15 && values.lifeExpectancy - values.retirementAge >= 1) {
    score += 3;
  }
  if (values.lifeExpectancy - values.retirementAge < 1) {
    score += 1;
  }

  //PortfolioGoal
  if (values.portfolioGoal == 'invest aggressively') {
    score += 5;
  }
  if (values.portfolioGoal == 'invest with caution') {
    score += 3;
  }
  if (values.portfolioGoal == 'avoid losing money') {
    score += 1;
  }

  // LongTermExpectation
  if (values.longTermExpectation == 'make a big profit') {
    score += 5;
  }
  if (values.longTermExpectation == 'earn a modest profit') {
    score += 3;
  }
  if (values.longTermExpectation == 'at least break even') {
    score += 1;
  }

  // Performance3YearGoal
  if (values.performance3YearGoal == 'can live if I lose money') {
    score += 5;
  }
  if (values.performance3YearGoal == 'must at least break even') {
    score += 3;
  }
  if (values.performance3YearGoal == 'must make a small profit') {
    score += 1;
  }

  //Performance3MonthGoal
  if (values.performance3MonthGoal == 'not worry about losses') {
    score += 5;
  }
  if (values.performance3MonthGoal == 'worry about a 10% loss') {
    score += 3;
  }
  if (values.performance3MonthGoal == 'worry about any loss') {
    score += 1;
  }

  //LostJob
  if (values.lostJob == 'more than six months') {
    score += 5;
  }
  if (values.lostJob == 'three to six months') {
    score += 3;
  }
  if (values.lostJob == 'less than three months') {
    score += 1;
  }

  //PortfolioPercentage
  if (values.portfolioPercentage == 'a minor part') {
    score += 5;
  }
  if (values.portfolioPercentage == 'an important part') {
    score += 3;
  }
  if (values.portfolioPercentage == 'the vast majority') {
    score += 1;
  }
  if (score <= 17) return 1;
  if (score > 17 && score <= 27) return 2;
  if (score > 27 && score <= 35) return 3;
  if (score > 35 && score <= 45) return 4;
};
exports.calculateScore = calculateScore;